/**
 * @license @tylertech/tyler-components-web
 * Copyright (C) 2019 Tyler Technologies, Inc.
 */
import { defineCustomElements } from '@tyler-components-web/core';
import { AccordionComponent } from './accordion';
import { AutocompleteComponent } from './autocomplete';
import { AvatarComponent } from './avatar';
import { BackdropComponent } from './backdrop';
import { BadgeComponent } from './badge';
import { BannerComponent } from './banner';
import { BottomSheetComponent } from './bottom-sheet';
import { BusyIndicatorComponent } from './busy-indicator';
import { ButtonComponent } from './button';
import { ButtonToggleComponent, ButtonToggleGroupComponent } from './button-toggle';
import { CalendarComponent } from './calendar';
import { CardComponent } from './card';
import { CheckboxComponent } from './checkbox';
import { ChipComponent, ChipSetComponent } from './chips';
import { ChipFieldComponent } from './chip-field';
import { ColorPickerComponent } from './color-picker';
import { DateRangePickerComponent } from './date-range-picker';
import { DatepickerComponent } from './datepicker';
import { DialogComponent } from './dialog';
import { DividerComponent } from './divider';
import { DrawerComponent } from './drawer';
import { ExpansionPanelComponent } from './expansion-panel';
import { FilePickerComponent } from './file-picker';
import { FloatingActionButton } from './floating-action-button';
import { FooterComponent } from './footer';
import { FooterItemComponent } from './footer/footer-item';
import { IconButtonComponent } from './icon-button';
import { InlineMessageComponent } from './inline-message';
import { LabelValueComponent } from './label-value';
import { LinearProgressComponent } from './linear-progress';
import { ListComponent } from './list';
import { ListItemComponent } from './list/list-item';
import { MenuComponent } from './menu';
import { AppLauncherComponent, OmnibarAppLauncherButtonComponent, OmnibarComponent, OmnibarHelpButtonComponent, OmnibarMenuButtonComponent, OmnibarNotificationButtonComponent, OmnibarProfileButtonComponent, OmnibarSearchComponent, ProfileCardComponent } from './omni';
import { OpenIconComponent } from './open-icon';
import { PageStateComponent } from './page-state';
import { PaginatorComponent } from './paginator';
import { PopupComponent } from './popup';
import { ProductIconComponent } from './product-icon';
import { ProgressSpinnerComponent } from './progress-spinner';
import { QuantityFieldComponent } from './quantity-field';
import { RadioComponent } from './radio';
import { RippleComponent } from './ripple';
import { ScaffoldComponent } from './scaffold';
import { OptionComponent, OptionGroupComponent, SelectComponent } from './select';
import { SkeletonComponent } from './skeleton';
import { SliderComponent } from './slider';
import { StepComponent, StepperComponent } from './stepper';
import { SwitchComponent } from './switch';
import { TableComponent } from './table';
import { TabBarComponent, TabComponent } from './tabs';
import { TextFieldComponent } from './text-field';
import { TimePickerComponent } from './time-picker';
import { ToastComponent } from './toast';
import { ToolbarComponent } from './toolbar';
import { TooltipComponent } from './tooltip';
import { ViewComponent, ViewSwitcherComponent } from './view-switcher';
import { IconComponent } from './icon';
import { SelectDropdownComponent } from './select/select-dropdown';
export * from './accordion';
export * from './autocomplete';
export * from './avatar';
export * from './backdrop';
export * from './badge';
export * from './banner';
export * from './bottom-sheet';
export * from './busy-indicator';
export * from './button';
export * from './button-toggle';
export * from './calendar';
export * from './card';
export * from './checkbox';
export * from './chips';
export * from './chip-field';
export * from './color-picker';
export { VERSION } from './constants';
export * from './core';
export * from './date-range-picker';
export * from './datepicker';
export * from './dialog';
export * from './divider';
export * from './drawer';
export * from './expansion-panel';
export * from './file-picker';
export * from './floating-action-button';
export * from './floating-label';
export * from './footer';
export * from './icon-button';
export * from './inline-message';
export * from './label-value';
export * from './linear-progress';
export * from './list';
export * from './menu';
export * from './omni';
export * from './open-icon';
export * from './page-state';
export * from './paginator';
export * from './popup';
export * from './product-icon';
export * from './progress-spinner';
export * from './quantity-field';
export * from './radio';
export * from './ripple';
export * from './scaffold';
export * from './select';
export * from './skeleton';
export * from './slider';
export * from './stepper';
export * from './switch';
export * from './table';
export * from './tabs';
export * from './text-field';
export * from './theme';
export * from './time-picker';
export * from './toast';
export * from './toolbar';
export * from './tooltip';
export * from './utils';
export * from './view-switcher';
export * from './icon';
var CUSTOM_ELEMENTS = [
    AccordionComponent,
    AvatarComponent,
    BackdropComponent,
    BadgeComponent,
    BannerComponent,
    BottomSheetComponent,
    BusyIndicatorComponent,
    ButtonComponent,
    ButtonToggleComponent,
    ButtonToggleGroupComponent,
    CalendarComponent,
    CardComponent,
    CheckboxComponent,
    ChipComponent,
    ChipSetComponent,
    ChipFieldComponent,
    ColorPickerComponent,
    DatepickerComponent,
    DialogComponent,
    DividerComponent,
    DrawerComponent,
    ExpansionPanelComponent,
    FilePickerComponent,
    FloatingActionButton,
    FooterComponent,
    FooterItemComponent,
    ProductIconComponent,
    IconComponent,
    IconButtonComponent,
    InlineMessageComponent,
    LabelValueComponent,
    LinearProgressComponent,
    ListComponent,
    ListItemComponent,
    MenuComponent,
    AppLauncherComponent,
    OmnibarComponent,
    OmnibarSearchComponent,
    OmnibarMenuButtonComponent,
    OmnibarAppLauncherButtonComponent,
    OmnibarNotificationButtonComponent,
    OmnibarHelpButtonComponent,
    OmnibarProfileButtonComponent,
    ProfileCardComponent,
    OpenIconComponent,
    OptionComponent,
    OptionGroupComponent,
    PageStateComponent,
    PaginatorComponent,
    PopupComponent,
    ProgressSpinnerComponent,
    QuantityFieldComponent,
    RadioComponent,
    RippleComponent,
    ScaffoldComponent,
    SelectComponent,
    SelectDropdownComponent,
    SkeletonComponent,
    SliderComponent,
    StepperComponent,
    StepComponent,
    SwitchComponent,
    TabBarComponent,
    TabComponent,
    TableComponent,
    TextFieldComponent,
    TimePickerComponent,
    ToastComponent,
    ToolbarComponent,
    TooltipComponent,
    ViewSwitcherComponent,
    ViewComponent,
    AutocompleteComponent,
    DateRangePickerComponent
];
/**
 * Registers all components in the library with the browser.
 */
export function defineComponents() {
    defineCustomElements(CUSTOM_ELEMENTS);
}
